import { componentStyleWithExtend } from '@/styling/util/component-style.ts';
import type { DatePickerDesignTokens } from '@primeuix/themes/types/datepicker';

export const datePickerStyle: ReturnType<typeof componentStyleWithExtend<DatePickerDesignTokens>> =
    componentStyleWithExtend<DatePickerDesignTokens>({
        extend: {},
        style: {},
        css: () => `
        .p-datepicker-select-month, .p-datepicker-select-year {
            font-family: inherit;
        }
    `,
    });
